import { apiSlice } from '../apiSlice';
import {
	ClickPageDTO,
	ClockPageFilter,
	ClockRequest,
} from '../DTO/app-setting/clock.interface';
import { SuccessResponse, Paginated } from '../DTO/common.interface';

export const clockApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getClockList: builder.query<
			SuccessResponse<Paginated<ClickPageDTO>>,
			ClockPageFilter
		>({
			query: (body) => ({
				url: `/web/ring/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['ClockList'],
		}),
		createClock: builder.mutation<SuccessResponse<any>, ClockRequest>({
			query: (body) => ({
				url: `/web/ring`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['ClockList'],
		}),
		updateClock: builder.mutation<SuccessResponse<any>, ClockRequest>({
			query: (body) => ({
				url: `/web/ring`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['ClockList'],
		}),
		deleteClock: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/ring/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['ClockList'],
		}),
		setDefaultClock: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/ring/default/${id}`,
				method: 'PUT',
			}),
			invalidatesTags: ['ClockList'],
		}),
	}),
});

export const {
	useGetClockListQuery,
	useCreateClockMutation,
	useDeleteClockMutation,
	useUpdateClockMutation,
	useSetDefaultClockMutation,
} = clockApiSlice;
